import { Injectable } from '@angular/core';
import { formatDate } from '@angular/common';

import { ReportEndpoint } from './report-endpoint.service';

import { MechanismType } from '../models/kappa/mechanism-type.model';
import { KappaForm } from '../models/report/kappa-form.model';
import { QcWeekDay } from '../models/report/qc-week-day.model';
import { QcWeekStEndDate } from '../models/report/qc-week-stend-date.model';
import { SubmissionType } from '../models/enums';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  private _xlsxContentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  private _dateFormat = 'dd_MM_y_hh_mm_ss_aa';
  private _dateFormatNoSeconds = 'MM_dd_yyyy hh_mm_a';

  get ReportContentType() { return this._xlsxContentType; }
  get FormattedDate() { return `${formatDate(Date.now(), this._dateFormat, 'en-US')}`; }
  get FormattedDateNoSeconds() { return `${formatDate(Date.now(), this._dateFormatNoSeconds, 'en-US')}`; }

  constructor(private reportEndpoint: ReportEndpoint) { }

  getKappaReport(kappaForm: KappaForm) {
    return this.reportEndpoint.getKappaReportEndpoint<ArrayBuffer>(kappaForm);
  }

  getAbstractSummaryReport(odpProjectWorkflowId: number) {
    return this.reportEndpoint.getAbstractSummaryReportEndpoint<ArrayBuffer>(odpProjectWorkflowId);
  }

  getAbstractValuesReport(odpProjectWorkflowId: number, year: string) {
    return this.reportEndpoint.getAbstractValuesReportEndpoint<ArrayBuffer>(odpProjectWorkflowId, year);
  }

  getWeeklyCoderReport(odpProjectWorkflowId: number, startDate: string, endDate: string) {
    return this.reportEndpoint.getWeeklyCoderReportEndpoint<ArrayBuffer>(odpProjectWorkflowId, startDate, endDate);
  }

  getWeeklyCoderConsensusReport(odpProjectWorkflowId: number, startDate: string, endDate: string, submissionType: SubmissionType) {
    return this.reportEndpoint.getWeeklyCoderConsensusReportEndpoint<ArrayBuffer>(odpProjectWorkflowId, startDate, endDate, submissionType);
  }

  getRecCompletedReport(odpProjectWorkflowId: number, startDate: string, endDate: string) {
    return this.reportEndpoint.getRecCompletedReportEndpoint<ArrayBuffer>(odpProjectWorkflowId, startDate, endDate);
  }

  getAbstractFYs(odpProjectWorkflowId: number) {
    return this.reportEndpoint.getAbstractFYsEndpoint<string[]>(odpProjectWorkflowId);
  }

  getQcDates() {
    return this.reportEndpoint.getQcDatesEndpoint<QcWeekDay[]>();
  }

  getQcDatesWithStart(startDate: string) {
    return this.reportEndpoint.getQcDatesWithStartEndpoint<QcWeekDay[]>(startDate);
  }

  getQcWeeksStEndDates() {
    return this.reportEndpoint.getQcWeeksStEndDatesEndpoint<QcWeekStEndDate[]>();
  }


  getMechanismTypes(odpProjectWorkflowId: number) {
    return this.reportEndpoint.getMechanismTypesEndpoint<MechanismType[]>(odpProjectWorkflowId);
  }

  getLastKappaReportDate(odpProjectWorkflowId: number) {
    return this.reportEndpoint.getLastKappaReportDateEndpoint(odpProjectWorkflowId);
  }

}
